import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-circle-progress',
  standalone: true,
  imports: [],
  templateUrl: './circle-progress.component.html',
  styleUrl: './circle-progress.component.scss',
})
export class CircleProgressComponent {
  @Input() set progressPercentage(value: number) {
    this.filledValue = Math.round((238.64000000000001 / 100) * value);
    this._progressPercentage = value;
  }
  filledValue = 0;
  _progressPercentage = 0;
  get progressPercentage(): number {
    return this._progressPercentage;
  }
}
